import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import PropTypes from 'prop-types';

import Modal from 'components/Modal';
import ItemPicker from 'components/ItemPicker';
import ErrorBoundary from 'components/ErrorBoundary';
import renderTeamTypeIcon from 'screens/TeamPickerModal/renderTeamTypeIcon';
import TeamTypeFilter from 'components/TeamTypeFilter';

import {useFetchTeams, useFetchTeamTypes} from 'actions/team';

function OwningTeamPickerModal({
	onSubmit,
	onClose,
	defaultSelectedItems,
	potentialOwningTeams,
	contentIds,
}) {
	const {t} = useTranslation();

	const [searchValue, setSearchValue] = useState('');
	const [selectedTeamType, setSelectedTeamType] = useState('');

	const {items: teamTypes} = useFetchTeamTypes();

	const renderFilter = () => (
		<TeamTypeFilter
			value={selectedTeamType}
			onChange={setSelectedTeamType}
			teamTypes={teamTypes}
		/>
	);

	const {
		items,
		hasNextPage,
		fetchNextPage,
		isError,
		isLoading,
		isFetchingNextPage,
	} = useFetchTeams({
		teamTypeId: selectedTeamType,
		search: searchValue,
		teamsIds: potentialOwningTeams,
		contentIds,
		includeCalculatedTeams: false,
	});

	const title = t('actions_change_owning_team');
	return (
		<Modal
			id="owning-team-picker-modal"
			aria-label={title}
			onRequestClose={onClose}
		>
			<ErrorBoundary>
				<ItemPicker
					isSingleItemPicker={true}
					title={title}
					defaultSelectedItems={defaultSelectedItems}
					onSearchValueChange={setSearchValue}
					renderItemIcon={
						teamTypes.length > 1 ? renderTeamTypeIcon : null
					}
					onSubmit={onSubmit}
					onClose={onClose}
					items={items}
					hasNextPage={hasNextPage}
					onFetchNextPage={fetchNextPage}
					renderFilterMenu={
						teamTypes.length > 1 ? renderFilter : null
					}
					isFetchingNextPage={isFetchingNextPage}
					isError={isError}
					isLoading={isLoading}
				/>
			</ErrorBoundary>
		</Modal>
	);
}

const ContentShape = PropTypes.shape({
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	name: PropTypes.string,
});

OwningTeamPickerModal.propTypes = {
	contentIds: PropTypes.array,
	potentialOwningTeams: PropTypes.arrayOf(PropTypes.number),
	defaultSelectedItems: PropTypes.arrayOf(ContentShape),
	onSubmit: PropTypes.func,
	onClose: PropTypes.func,
};

export default OwningTeamPickerModal;
